// Browser side of GPX export: the XML itself comes from @motogo/shared (buildRouteGpx);
// this is just the download trigger. Mobile shares the XML builder but uses the native
// share sheet instead.

export function downloadGpx(filename: string, xml: string): void {
  const blob = new Blob([xml], { type: 'application/gpx+xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Defer the revoke: some browsers (historically Firefox, some mobile WebKit) haven't begun
  // reading the blob synchronously after click(), and revoking immediately cancels the save.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
